import React from 'react';

import RedirectTo404Block from '../../blocks/RedirectTo404';

const RedirectTo404 = () => <RedirectTo404Block name="$GENERAL:redirect_to_404" />;
export default RedirectTo404;
